import NossaEmpresa from "../../components/SobreComponents/NossaEmpresaSection/nossa-empresa-section";
import VisaoSection from "../../components/SobreComponents/VisaoSection/visao-section";
import ValoresSection from "../../components/SobreComponents/ValoresSection/valores-section";
import EquipeSection from "../../components/SobreComponents/EquipeSection/equipe-section";
import styles from "./sobre.module.css";

interface IProps {
  onHandlePages: any;
}

const SobrePage = ({ onHandlePages }: IProps) => {
  return (
    <main className={styles.sobre_main}>
      <NossaEmpresa />
      <VisaoSection />
      <ValoresSection />
      <EquipeSection onHandlePages={onHandlePages} />
    </main>
  );
};

export default SobrePage;
